import toast from "react-hot-toast";

/**
 * 全站統一 Toast 介面，取代 alert()。
 * 需在 App 內掛載 <Toaster />（react-hot-toast）。
 */
export const appToast = {
  success: (message: string) => {
    toast.success(message, { duration: 3000 });
  },
  error: (message: string) => {
    toast.error(message, { duration: 4000 });
  },
  /** 中性提示（非成功非錯誤，例：多鐵牌分屬不同客戶 → 放棄自動綁定） */
  info: (message: string) => {
    toast(message, { duration: 3500 });
  },
};

export default appToast;
